import { AxiosResponse } from "axios";
import BaseApi from "./BaseApi";
import AxiosService from "./Axios";

const BASE_URL = '/user/permission';

class PermissionApi {
    
    public async getCurrentUserPermissions(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/current-composite-user-permissions');
    }

    public async getCurrentUserDevices(): Promise<AxiosResponse<any>> {
        return AxiosService.get(`${BASE_URL}/current-composite-user-devices`);
    }

    public async getCurrentTenantFeatures(): Promise<AxiosResponse<any>> {
        return AxiosService.get(`${BASE_URL}/current-tenant-features`);
    }

    public async getUserDevices(userId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(`${BASE_URL}/user-devices`, {
            params: {
                userId: userId,
            }
        });
    }

    public async setUserDevices(request: SetUserDevicesRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post('/user/permission/set-user-devices', request);
    }

    
    public async getRoles(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/role/all');
    }

    public async getRole(roleId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/role/get', {
            params: {id: roleId }
        });
    }

    public async createRole(role: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/role/create`, role);
    }

    public async updateRole(role: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/role/update`, role);
    }

    public async deleteRole(roleId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/role/delete', {
            id: roleId
        });
    }

    public async getPermissionMetas(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/metas');
    }

    public async getRolePermissions(roleId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/role-permissions', {
            params: { roleId: roleId }
        });
    }

    public async getUserRoles(userId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/user-roles', {
            params: { userId: userId }
        });
    }

    public async setUserRoles(userId: string, roleIds: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/set-user-roles`, {
            userId: userId,
            roleIds: roleIds
        });
    }

    public async setRolePermissions(roleId: string, permissions: string[]): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + `/set-role-permissions`, {
            roleId: roleId,
            permissionCodePaths: permissions
        });
    }
}

interface SetUserDevicesRequest {
    userId: string;
    deviceIds: string[];
}

export default PermissionApi;

